import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function submitEarlyAccess(payload) {
  const res = await axios.post(`${API}/early-access`, payload);
  return res.data;
}

export async function getWaitlistCount() {
  const res = await axios.get(`${API}/early-access/count`);
  return res.data?.count ?? 0;
}

/* ------------------------------- Admin ------------------------------- */
const authHeader = (token) => ({ headers: { "X-Admin-Token": token } });

export async function adminVerify(token) {
  const res = await axios.get(`${API}/admin/verify`, authHeader(token));
  return res.data?.ok === true;
}

export async function adminListSignups(token) {
  const res = await axios.get(`${API}/admin/early-access`, authHeader(token));
  return res.data ?? { count: 0, items: [] };
}

export async function adminExportCsv(token) {
  const res = await axios.get(`${API}/admin/early-access/export`, {
    ...authHeader(token),
    responseType: "blob",
  });
  const disposition = res.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : "procurmo-warteliste.csv";
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
